<tui-textfield tuiTextfieldSize="s" style="width: 100%">
  <input
    tuiInputDateRange
    [formControl]="control"
    placeholder="Выберите даты"
  />
  <tui-calendar-range *tuiTextfieldDropdown (valueChange)="dateFilter($event)"/>
</tui-textfield>
